import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { OrgAdminAuditLog, RoleEditor } from "@/modules/admin";

export default function AdminRolesPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.roles.pageTitle")}
      description={t("admin.roles.pageDescription")}
    >
      <div className="space-y-6">
        <RoleEditor />
        <PermissionGate perm="role.read">
          <OrgAdminAuditLog />
        </PermissionGate>
      </div>
    </AppLayout>
  );
}
